import type { Database } from '@/integrations/supabase/types';

// Columns of public.user_profiles that anon/authenticated roles are granted to read.
// `wallet_balance_cents` is intentionally excluded (service_role only), so never
// use `select('*')` on user_profiles, the whole query gets rejected with a
// permission error and the profile silently disappears from the UI.
export const PUBLIC_PROFILE_COLUMNS =
  'id, username, full_name, bio, avatar_url, avatar_background, total_xp, current_streak, longest_streak, current_league, league_position, achievements_unlocked, created_at, updated_at, last_active_date' as const;

export type PublicUserProfile = Database['public']['Tables']['user_profiles']['Row'];
